import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { actions as accountsActions } from "reducers/accounts";
import { isEqual } from "lodash-es";

const months = [
    { value: "all", label: "todos" },
    { value: "1", label: "enero" },
    { value: "2", label: "febrero" },
    { value: "3", label: "marzo" },
    { value: "4", label: "abril" },
    { value: "5", label: "mayo" },
    { value: "6", label: "junio" },
    { value: "7", label: "julio" },
    { value: "8", label: "agosto" },
    { value: "9", label: "septiembre" },
    { value: "10", label: "octubre" },
    { value: "11", label: "noviembre" },
    { value: "12", label: "diciembre" },
];

const useStatements = (filters) => {
    const prevFilterRef = useRef(filters);

    const dispatch = useDispatch();

    const now = new Date();
    let resquestMonth = "todos";
    let yearRequest = now.getFullYear().toString();

    useEffect(() => {
        if (!isEqual(prevFilterRef.current, filters)) {
            if (filters.month) {
                resquestMonth = months.find((o) => o.value === filters.month).label;
            }

            if (filters.year) {
                yearRequest = filters.year;
            }

            dispatch(accountsActions.listStatements(yearRequest, resquestMonth, filters?.accountId));

            // Update the previous prop value for the next comparison
            prevFilterRef.current = filters;
        }
    }, [filters]);
};

export default useStatements;
